import { FormProvider } from "react-hook-form";

import { openWhatsApp } from "@luce/core/platform";
import { Box, Button, Divider, FormPhoneNumberField, Pressable, Typography } from "@luce/ui";

import { LUCE_CS_NUMBER } from "../../../shared";
import { useChangePhoneNumberContext } from "../change-phone-number-context";
import { FOREIGN_NUMBER_CS_MESSAGE } from "../lib";

export function ChangePhoneNumberForm() {
  const { form, isSupportedNumber, isSendingOtp, onSubmit } = useChangePhoneNumberContext();
  const currentPhoneNumber = form.watch("currentPhoneNumber");

  return (
    <FormProvider {...form}>
      <Box className="gap-spacing-lg flex flex-col">
        <FormPhoneNumberField name="currentPhoneNumber" label="Current Phone Number" disabled />
        <FormPhoneNumberField
          name="newPhoneNumber"
          label="New Phone Number"
          disabled={!isSupportedNumber}
        />
        {currentPhoneNumber && !isSupportedNumber && (
          <Typography variant="body-sm" color="neutral-foreground-intermediate">
            Only Singapore phone numbers are supported. Need a different number?{" "}
            <Pressable
              asChild
              accessibilityRole="link"
              onClick={() => openWhatsApp(LUCE_CS_NUMBER, FOREIGN_NUMBER_CS_MESSAGE)}
            >
              <Typography variant="body-sm" color="brand-primary">
                Get help
              </Typography>
            </Pressable>
          </Typography>
        )}
        <Divider />
        <Button
          size="lg"
          fullWidth
          label="Continue"
          loading={isSendingOtp}
          disabled={!isSupportedNumber}
          onClick={onSubmit}
        />
      </Box>
    </FormProvider>
  );
}
